import { useLocation } from 'react-router'

export const usePathname = () => {
  const { pathname } = useLocation()

  const pathNameStripped =
    pathname.length > 1 && pathname.at(-1) === '/'
      ? pathname.substring(0, pathname.length - 1)
      : pathname

  return { pathname: pathNameStripped }
}
